import React, { useState, useEffect } from 'react';
import { PDFExport } from '@progress/kendo-react-pdf';
import TableRow from "./TableRow"

const DashboardTable = React.forwardRef(({ searchTerm, data }, ref) => {
    const [filterResult, setFilterResult] = useState([]);

    useEffect(() => {
        const filtered = data.filter(data => data.member.toLowerCase().includes(searchTerm.toLowerCase()) || data.mobile.toString().toLowerCase().includes(searchTerm.toLowerCase()) || data.pkgGroup.toLowerCase().includes(searchTerm.toLowerCase()) || data.pkg.toLowerCase().includes(searchTerm.toLowerCase()) || data.message.toLowerCase().includes(searchTerm.toLowerCase()));

        setFilterResult(filtered);
    }, [searchTerm, data])


    return (
        <>
            <div className="flex flex-col">
                <div className="overflow-x-auto sm:mx-3 md:mx-4 lg:mx-3  ">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <PDFExport paperSize="A4" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                                <table className="min-w-full border text-center" id='table-to-xls'>

                                    <thead className="tableborder font-semibold">
                                        <tr className="tableborder">
                                            <TableRow
                                                tableTitle="SNo"
                                            />
                                            <TableRow
                                                tableTitle="Member"
                                            />
                                            <TableRow
                                                tableTitle="Mobile No"
                                            />
                                            <TableRow
                                                tableTitle="Package group"
                                            />
                                            <TableRow
                                                tableTitle="Package"
                                            />
                                            <TableRow
                                                tableTitle="Starting Date"
                                            />
                                            <TableRow
                                                tableTitle="Expiry Date"
                                            />
                                            <TableRow
                                                tableTitle="Message"
                                            />
                                        </tr>
                                    </thead>

                                    <tbody className='text-sm font-normal hover:bg-gray-200'>
                                        <tr className="tableborder">
                                            <td colSpan="8" >No data Found...</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </PDFExport>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
});

export default DashboardTable
